import { getZrmUserInfo } from '@zg-rentals/clickstream';
import { trackUserEvent } from './index';
import type { ZrmClickstreamUser } from '@zg-rentals/clickstream';

// https://dataportal.zillowgroup.net/event-registry/3644
export const emitErrorEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_template_id: '167',
      event_template_version_id: '1',
      event_type_id: '3643',
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'zrm_price_my_rental_results_page|error',
      trigger_type_nm: 'view',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'zrm_price_my_rental_results_page|error',
    },
    semantic: {
      semantic_event_nm: 'view_content',
      topic_tag_txt: ['zrm_growth'],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/3609
export const emitDownloadPDFEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_template_id: '167',
      event_template_version_id: '1',
      event_type_id: '3609',
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'zrm_price_my_rental_results_page',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'download_pdf_button',
      trigger_source_nm: 'price_my_rental_click_pdf',
    },
    semantic: {
      semantic_event_nm: 'zrm_price_my_rental',
      topic_tag_txt: ['zrm_growth'],
    },
    ...getZrmUserInfo(user),
  });
